import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { CartItem } from '../types';

interface CartBarProps {
  items: CartItem[];
  onClick: () => void;
  primaryColor?: string;
}

const CartBar: React.FC<CartBarProps> = ({ items, onClick, primaryColor = '#111827' }) => {
  if (items.length === 0) return null;

  const count = items.reduce((sum, item) => sum + item.quantity, 0);
  const total = items.reduce((sum, item) => {
    const price = item.price || 0;
    const promo = item.promotional_price || 0;
    const finalPrice = (promo > 0 && promo < price) ? promo : price;
    return sum + (finalPrice * item.quantity);
  }, 0);

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 pb-6 bg-gradient-to-t from-white via-white/80 to-transparent z-40 pointer-events-none">
      <button
        onClick={onClick}
        className="pointer-events-auto w-full max-w-md mx-auto text-white py-3.5 px-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.15)] flex items-center justify-center gap-6 transition-transform active:scale-[0.98]"
        style={{ backgroundColor: primaryColor }}
      >
        <div className="flex items-center gap-4">
          <div className="bg-black/20 w-10 h-10 rounded-full flex items-center justify-center relative">
            <ShoppingBag size={20} />
            <span
              className="absolute -top-1 -right-1 text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full border-2"
              style={{ backgroundColor: '#10b981', borderColor: primaryColor }}
            >
              {count}
            </span>
          </div>
          <div className="text-left">
            <p className="text-[10px] text-white/80 uppercase tracking-wider font-semibold mb-0.5">Subtotal</p>
            <p className="font-bold text-base leading-none">R$ {total.toFixed(2).replace('.', ',')}</p>
          </div>
        </div>

        {/* Divisor vertical suave */}
        <div className="w-px h-8 bg-white/20 mx-2"></div>

        <span className="font-bold text-sm uppercase tracking-wide">Fechar Pedido</span>
      </button>
    </div>
  );
};

export default CartBar;
